export default "body * {\n    max-width: 100%;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n}";